import LoginForm from "../components/LoginForm";

// Admin-only login (unlisted route /admin-login — not linked from the navbar).
export default function Home() {
  return <LoginForm role="admin" />;
}
